import React from "react";
import { uploadFiles, FileMetaRow } from "../utils/uploadFiles";
import { toast } from "react-toastify";

interface UploadButtonProps {
    filesMeta: FileMetaRow[];
    entityMap: Record<string, any[]>;
    setFilesMeta: React.Dispatch<React.SetStateAction<FileMetaRow[]>>;
    setUploading: (val: boolean) => void;
    setUploadProgress?: (val: number) => void;
    endpoint: string;
    uploadMode?: "upload" | "confirm";
    label?: string;
    uploading: boolean;
}


export const UploadButton: React.FC<UploadButtonProps> = ({
    filesMeta,
    entityMap,
    setFilesMeta,
    uploading,
    setUploading,
    setUploadProgress,
    endpoint,
    uploadMode = "upload",
    label = "Upload",
}) => {
        const handleClick = async () => {
            
            const invalidTypeDocumentTypeRows = filesMeta.filter((row) => {
                const docType = row.documentType?.toUpperCase();
                const type = row.entityType?.toUpperCase();
                return (
                    ["AGM", "QUARTERLY NOTES", "IC MEMO","TermSheets"].includes(docType || "") &&
                    type !== "PM"
                );
            });

            if(invalidTypeDocumentTypeRows.length > 0) {
                toast.error("Document Type (AGM, IC Memo, Quarterly Notes must have Type as 'PM'). Please correct them");
                return;
            }

            await uploadFiles({
                filesMeta,
                entityMap,
                setFilesMeta,
                setUploading,
                setUploadProgress,
                endpoint,
                uploadMode
            });
        };

        return (
            <button 
                data-testid={`upload-button-${uploadMode}`}
                // className="upload-btn"
                disabled={(uploading || filesMeta.length === 0 ) }
                onClick={handleClick}
                className={`px-4 py-2 rounded text-white rounded text-sm  transition ${filesMeta.length === 0  || uploading
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-600 hover:bg-blue-700'
                   }`}
                >
                    {label}
                </button>
        );
};